import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 23px;
  display: flex;
  span {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }
`;
